export default {
    en: {
        id: 'diagram3b4-2',
        blocks: [
            {
                task: 'S = Believe entrepreneurs succeed either because they plan carefully or bet long odds',
                answer: 'Believe Xs succeed because they do Y or Z',
                title: "S = ",
                modelName: 's'
            },
            {
                task: 'C = But most successful new businesses don’t adhere to a script, nor do they bet on long odds',
                answer: 'Actually do neither',
                title: "C = ",
                modelName: 'c'
            },
            {
                task: 'Q = How do they succeed?',
                answer: 'How succeed?',
                title: "Q = ",
                modelName: 'q'
            },
            {
                task: 'A = They blend two contradictory skills: careful analytical thinking and a willingness to push boundaries.',
                answer: 'Blend contradictory skills',
                title: "A = ",
                modelName: 'a'
            }
        ],
        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
        correctAnswers: 4
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4a/practiceInSeeing/i18n/exercise2.js